import { NavLink, Outlet } from 'react-router-dom';

export function Layout() {
  return (
    <div className="shell">
      <header className="header">
        <div className="wrap header-row">
          <NavLink to="/" className="brand" end>
            <img className="mark" src={`${process.env.PUBLIC_URL}/icon.png`} alt="" />
            UllSpeak
          </NavLink>
          <nav className="nav">
            <NavLink to="/" end>
              Product
            </NavLink>
            <NavLink to="/support">Support</NavLink>
            <NavLink to="/privacy-policy">Privacy</NavLink>
            <NavLink to="/terms">Terms</NavLink>
          </nav>
        </div>
      </header>
      <main>
        <div className="wrap">
          <Outlet />
        </div>
      </main>
      <footer className="footer">
        <div className="wrap footer-row">
          <span>Damir Rashidov, 2026</span>
          <span>
            <a href="mailto:damir@rashidov.eu">damir@rashidov.eu</a>
            {' · '}
            Estonia
          </span>
        </div>
      </footer>
    </div>
  );
}
